// extracted by mini-css-extract-plugin
export default {"row":"AttachmentChipsRow_row__WpnQp","chip":"AttachmentChipsRow_chip__m2Why","spinner":"AttachmentChipsRow_spinner__M6wtz","chip-spin":"AttachmentChipsRow_chip-spin__BgrwL"};